var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q-summit-guide pt-4"},_vm._l((_vm.steps),function(step,index){return _c('QSummitSidebarGuideStep',{key:step.title,attrs:{"to":step.Url,"step":step,"index":index,"last":index !== _vm.steps.length - 1,"current-step":_vm.currentStep}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }